'use client'

interface TechStackTagProps {
  tech: string
}

export function TechStackTag({ tech }: TechStackTagProps) {
  return (
    <span className="inline-block px-2 py-0.5 text-xs font-medium rounded bg-gray-100 text-gray-700">
      {tech}
    </span>
  )
}
